export const BusinessViewTypes = {
  REGULAR: 1,
  LINEAR: 2,
  FASHION: 3,
  MAGAZINE: 4,
}

export const BUSINESS_VIEWS = [
  { id: BusinessViewTypes.REGULAR, name: 'Regular' },
  { id: BusinessViewTypes.LINEAR, name: 'Linear' },
  { id: BusinessViewTypes.FASHION, name: 'Fashion' },
  { id: BusinessViewTypes.MAGAZINE, name: 'Magazine' },
]

export function businessViewById(viewType) {
  const id = Number(viewType)
  return BUSINESS_VIEWS.find((view) => view.id === id) || BUSINESS_VIEWS[0]
}
